<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<con-page-layout>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'namespaces_title' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'namespaces_subTitle' | translate }}</div>
  <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="end start">
    <div>
      <ng-container>
        <button mat-raised-button color="primary" (click)="exportDataToExcel()">
          {{ 'export_data' | translate }}
        </button>
      </ng-container>
    </div>
    <div>
      <ng-container>
        <a mat-raised-button color="primary" (click)="refresh()">
          <mat-icon>cached</mat-icon> {{ 're-evaluate' | translate }}
        </a>
      </ng-container>
    </div>
  </div>
  <br />

  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <div  *ngIf="media.isActive('lg') || media.isActive('xl') || media.isActive('md')" class="matTable-container">
      <mat-table matSort #table [dataSource]="dataSource"
        class="mat-elevation-z8">
  
        <!-- Account Name Column -->
        <ng-container cdkColumnDef="account_name">
          <mat-header-cell fxFlex="15%" *cdkHeaderCellDef mat-sort-header>{{ 'account_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="15%" *cdkCellDef="let namespace"> {{namespace.account_name}} </mat-cell>
        </ng-container>
  
        <!-- Account ID Column -->
        <ng-container cdkColumnDef="account_id">
          <mat-header-cell fxFlex="25%" *cdkHeaderCellDef mat-sort-header>{{ 'account_id' | translate }}</mat-header-cell>
          <mat-cell fxFlex="25%" *cdkCellDef="let namespace"> {{namespace.account_id}} </mat-cell>
        </ng-container>
  
        <!-- Namespace Name Column -->
        <ng-container cdkColumnDef="namespace_name">
          <mat-header-cell fxFlex="15%" *cdkHeaderCellDef mat-sort-header>{{ 'namespace_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="15%" *cdkCellDef="let namespace"> {{namespace.name}} </mat-cell>
        </ng-container>
  
        <!-- Namespace ID Column -->
        <ng-container cdkColumnDef="namespace_id">
          <mat-header-cell fxFlex="25%" *cdkHeaderCellDef mat-sort-header>{{ 'namespace_id' | translate }}</mat-header-cell>
          <mat-cell fxFlex="25%" *cdkCellDef="let namespace"> {{namespace.id}} </mat-cell>
        </ng-container>
  
        <!-- Region Column -->
        <ng-container cdkColumnDef="region">
          <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'region' | translate }}</mat-header-cell>
          <mat-cell fxFlex="10%" *cdkCellDef="let namespace"> {{namespace.region}} </mat-cell>
        </ng-container>
  
        <!-- State Column -->
        <ng-container cdkColumnDef="state">
          <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'state' | translate }}</mat-header-cell>
          <mat-cell fxFlex="10%" *cdkCellDef="let namespace"> {{namespace.state}} </mat-cell>
        </ng-container>
  
        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
    
    <br />

    <!-- Mobile view -->
    <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md'))" class="mobile-list">

      <mat-list-item *ngFor="let namespace of dataSource.data">
        <div class="mobile-card">

          <div class="field">
            <span class="label">{{ 'account_name' | translate }}</span>
            <span class="value breakword">{{ namespace.account_name }}</span>
          </div>

          <div class="field">
            <span class="label">{{ 'namespace_name' | translate }}</span>
            <span class="value breakword">{{ namespace.name }}</span>
          </div>

          <div class="field">
            <span class="label">{{ 'namespace_id' | translate }}</span>
            <span class="value breakword">{{ namespace.id }}</span>
          </div>

          <div class="field">
            <span class="label">{{ 'namespace_state' | translate }}</span>
            <span class="value">{{ namespace.state }}</span>
          </div>

        </div>
      </mat-list-item>

    </mat-list>

  </con-page-layout-content>
</con-page-layout>
